import { Box, Container, Grid, Typography, List, ListItem, ListItemIcon, ListItemText, useTheme, IconButton, Chip, alpha } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RouterIcon from '@mui/icons-material/Router';
import HubIcon from '@mui/icons-material/Hub';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DnsIcon from '@mui/icons-material/Dns';
import HistoryIcon from '@mui/icons-material/History';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import DashboardIcon from '@mui/icons-material/SpaceDashboard';
import PeopleIcon from '@mui/icons-material/People';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SettingsIcon from '@mui/icons-material/Settings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import DescriptionIcon from '@mui/icons-material/Description';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useState, useEffect } from 'react';
import Seo from '../components/Seo';


import dash1 from '../assets/dashOne.png';
import dash2 from '../assets/dashTwo.png';
import dash3 from '../assets/dashThree.png';
import warehouse0 from '../assets/war0.png';
import warehouse1 from '../assets/ware1.png';
import warehouse2 from '../assets/ware2.png';
import warehouse3 from '../assets/ware3.png';
import reporting1 from '../assets/rep1.png';
import reporting2 from '../assets/rep2.png';
import reporting3 from '../assets/rep3.png';
import reporting4 from '../assets/rep4.png';
import service1 from '../assets/ser1.png';
import service2 from '../assets/ser2.png';
import service3 from '../assets/ser3.png';
import service4 from '../assets/ser4.png';
import service5 from '../assets/ser5.png';
import service6 from '../assets/ser6.png';


//freeRadius
import freeRadius1 from '../assets/new/freeRadiusMng.png';
import freeRadius2 from '../assets/new/freeRadiusServices.jpg';
import freeRadius3 from '../assets/new/editNas.jpg';
import freeRadius4 from '../assets/new/editService.jpg';

//olt
import olt1 from '../assets/new/olt1.png';
import olt2 from '../assets/new/olt2.png';
import olt3 from '../assets/new/olt3.png';
import olt4 from '../assets/new/olt4.png';
import olt5 from '../assets/new/olt5.png';
import olt6 from '../assets/new/olt6.png';
import olt7 from '../assets/new/onu1.png';
import olt8 from '../assets/new/onu2.png';
import olt9 from '../assets/new/onu3.png';

//fiscalization
import fiscal1 from '../assets/new/fiscal.png';
import fiscal2 from '../assets/new/fiscal2.png';
import fiscal3 from '../assets/new/fiscal3.png';

//dns
import dns1 from '../assets/new/DNS.png';

//logs
import logs1 from '../assets/new/sysLog.png';
import logs2 from '../assets/new/syslog2.jpg';

//connect
import connect1 from '../assets/new/onlinePayment1.png';
import connect2 from '../assets/new/onlinePayment2.png';
import connect3 from '../assets/new/onlinePayment3.png';
import connect4 from '../assets/new/onlinePayment4.png';
import connect5 from '../assets/new/onlinePayment5.png';
import connect6 from '../assets/new/onlinePayment6.png';
import connect7 from '../assets/new/onlinePayment7.png';
import connect8 from '../assets/new/onlinePayment8.png';
import connect9 from '../assets/new/onlinePayment9.png';

//payment
import payment1 from '../assets/new/payment1.png';
import payment2 from '../assets/new/payment2.png';
import payment3 from '../assets/new/payment3.png';
import payment4 from '../assets/new/payment4.png';


import { moduleColors } from '../theme';

const FeatureHeader = () => {
  const theme = useTheme();
  return (
    <Box sx={{ bgcolor: 'background.default', pt: { xs: 12, md: 16 }, pb: { xs: 6, md: 8 }, textAlign: 'center' }}>
      <Container>
        <Typography variant="overline" sx={{ color: 'primary.main', display: 'block', mb: 1.5 }}>
          Features
        </Typography>
        <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
          One platform, every module
        </Typography>
        <Typography variant="subtitle1" sx={{ maxWidth: 760, mx: 'auto', color: theme.palette.text.secondary }}>
          From billing and FreeRadius internet to OLT management, fiscalization and
          online payments — explore everything SOLVENDA does for your ISP.
        </Typography>
      </Container>
    </Box>
  );
};

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    if (images.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [images.length]);

  const handlePrev = () => setCurrentIndex((p) => (p - 1 + images.length) % images.length);
  const handleNext = () => setCurrentIndex((p) => (p + 1) % images.length);

  if (images.length <= 1) {
    return (
      <Box
        component="img"
        src={images[0].url}
        alt={images[0].alt}
        sx={{ width: '100%', height: 'auto', borderRadius: 3, boxShadow: '0 20px 50px rgba(0,0,0,0.3)' }}
      />
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        component="img"
        src={images[currentIndex].url}
        alt={images[currentIndex].alt}
        sx={{ width: '100%', height: 'auto', borderRadius: 3, boxShadow: '0 20px 50px rgba(0,0,0,0.3)', transition: 'opacity 0.5s ease-in-out' }}
      />
      <IconButton onClick={handlePrev} size="small" sx={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', bgcolor: alpha('#000', 0.5), color: '#fff', '&:hover': { bgcolor: alpha('#000', 0.7) } }}>
        <ArrowBackIosNewIcon fontSize="small" />
      </IconButton>
      <IconButton onClick={handleNext} size="small" sx={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', bgcolor: alpha('#000', 0.5), color: '#fff', '&:hover': { bgcolor: alpha('#000', 0.7) } }}>
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 1 }}>
        {images.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentIndex(index)}
            sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: currentIndex === index ? theme.palette.primary.main : alpha(theme.palette.text.primary, 0.2), cursor: 'pointer', transition: 'background-color 0.3s' }}
          />
        ))}
      </Box>
    </Box>
  );
};

const FeatureDetailSection = ({ icon, title, description, bulletPoints, images, reversed, color, badge, index }) => {
  const theme = useTheme();
  const accent = color || theme.palette.primary.main;
  const imageArray = images || [{ url: '', alt: '' }];

  return (
    <Box sx={{ py: { xs: 6, md: 9 }, bgcolor: index % 2 === 0 ? 'background.default' : 'background.paper' }}>
      <Container>
        <Grid container spacing={6} direction={reversed ? 'row-reverse' : 'row'} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 72,
                height: 72,
                borderRadius: 3,
                bgcolor: alpha(accent, 0.14),
                color: accent,
                mb: 3,
              }}
            >
              {icon}
            </Box>
            <TitleRow badge={badge} accent={accent} title={title} />
            <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
              {description}
            </Typography>
            <List>
              {bulletPoints.map((point) => (
                <ListItem key={point} sx={{ p: 0, mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleIcon sx={{ color: accent }} fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={point} />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item xs={12} md={6}>
            <ImageCarousel images={imageArray} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

// Title + optional badge row
const TitleRow = ({ title, badge, accent }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5, mb: 1.5 }}>
    <Typography variant="h3" component="h2">
      {title}
    </Typography>
    {badge && (
      <Chip
        label={badge}
        size="small"
        sx={{ bgcolor: alpha(accent, 0.16), color: accent, fontWeight: 700 }}
      />
    )}
  </Box>
);

const features = [
  {
    icon: <RouterIcon sx={{ fontSize: 36 }} />,
    color: moduleColors.radius,
    badge: 'SolvendaRadius',
    title: 'FreeRadius internet, built in',
    description:
      'Distribute internet without any extra software. SolvendaRadius brings FreeRadius user management, speed profiles and NAS integration straight into Solvenda — and replaces the normal Internet module.',
    bulletPoints: [
      'FreeRadius user management and packets',
      'Speed profiles and expiry control',
      'NAS / MikroTik integration',
      'Payment-based activation and deactivation',
      'DNS servers and watch activity',
    ],
    images: [
      { url: freeRadius1, alt: 'SolvendaRadius management' },
      { url: freeRadius2, alt: 'Solvenda configuration with FreeRadius' },
      { url: freeRadius3, alt: 'Edit NAS' },
      { url: freeRadius4, alt: 'Edit Service' },
    ],
  },
  {
    icon: <HubIcon sx={{ fontSize: 36 }} />,
    color: moduleColors.olt,
    badge: 'ZTE C320 / C300 / C600',
    title: 'OLT & ONU management',
    description:
      'Manage your fiber network end to end — uplinks, VLANs, speed profiles, ONU/ONT signals, reboot and provisioning — without leaving Solvenda. Huawei support is coming soon.',
    bulletPoints: [
      'OLT dashboard and devices',
      'ONUs and unauthorized ONU detection',
      'ONU types and speed profiles',
      'Signals, reboot and provisioning',
      'VLAN, uplink and service configuration',
    ],
    images: [{ url: olt1, alt: 'Solvenda OLT management' }, { url: olt2, alt: 'Solvenda OLT management' }, { url: olt3, alt: 'Solvenda OLT management' }, { url: olt4, alt: 'Solvenda OLT management' }, { url: olt5, alt: 'Solvenda OLT management' }, { url: olt6, alt: 'Solvenda OLT management' }, { url: olt7, alt: 'Solvenda OLT management' }, { url: olt8, alt: 'Solvenda OLT management' }, { url: olt9, alt: 'Solvenda OLT management' }],
    reversed: false,
  },
  {
    icon: <CreditScoreIcon sx={{ fontSize: 36 }} />,
    color: moduleColors.connect,
    badge: 'connect.solvenda.org',
    title: 'Online card payments',
    description:
      'Give your subscribers a hosted page to pay by credit or debit card. No monthly fee — you only pay a small fee per successful payment, and everything syncs back into Solvenda.',
    bulletPoints: [
      'Hosted online payment page',
      'Gateway payments and status tracking',
      'Store locations and receipts',
      'Support tickets and account review',
      '50 ALL flat under 5,000 ALL · 2% + 20 ALL above',
    ],
    images: [
      { url: connect1, alt: 'Payments overview' },
      { url: connect2, alt: 'Payments overview' },
      { url: connect3, alt: 'Payments overview' },
      { url: connect4, alt: 'Payments overview' },
      { url: connect5, alt: 'Payments overview' },
      { url: connect6, alt: 'Payments overview' },
      { url: connect7, alt: 'Payments overview' },
      { url: connect8, alt: 'Payments overview' },
      { url: connect9, alt: 'Payments overview' },
    ],
    reversed: true,
  },
  {
    icon: <ReceiptLongIcon sx={{ fontSize: 36 }} />,
    color: moduleColors.fiscal,
    badge: 'Fiscalization',
    title: 'Compliant fiscal invoices',
    description:
      'Turn the payments you already collect into compliant Albanian fiscal invoices. Issue them one by one or in bulk, and let operators fiscalize automatically as they collect.',
    bulletPoints: [
      'Fiscalize payments in one click',
      'Bulk fiscalization of many payments',
      'Operator auto-fiscalization',
      'Fiscal invoice tracking and error handling',
      'Fully integrated with your payment flow',
    ],
    images: [
      { url: fiscal1, alt: 'Fiscalization' },
      { url: fiscal2, alt: 'Fiscalization' },
      { url: fiscal3, alt: 'Fiscalization' },
    ],
  },
  {
    icon: <DnsIcon sx={{ fontSize: 36 }} />,
    color: moduleColors.dns,
    badge: 'Add-on · €15/mo',
    title: 'DNS control & domain filtering',
    description:
      'Run your own DNS and decide what your subscribers can reach. Manage DNS servers, apply domain restrictions and keep allow/block lists — on any engine, not just SolvendaRadius.',
    bulletPoints: [
      'DNS server management',
      'Domain restriction and filtering',
      'Works with Internet or SolvendaRadius',
      'Tied into watch activity and logs',
    ],
    images: [{ url: dns1, alt: 'Solvenda DNS servers configuration' }],
    reversed: true,
  },
  {
    icon: <HistoryIcon sx={{ fontSize: 36 }} />,
    color: moduleColors.logs,
    badge: 'Compliance · €20/mo',
    title: 'Logs History for legal retention',
    description:
      'ISPs are required to retain connection logs for up to 2 years. We configure a storage server and integrate it with Solvenda, installing the right filters on your MikroTik or Cisco NAS — so every firewall connection is recorded and searchable.',
    bulletPoints: [
      'Firewall connection logs (FW-CONN, Src-Dst) per NAS',
      'MikroTik or Cisco filter configuration',
      'Dedicated storage server integration',
      'Retain and search logs for 2+ years',
      'Built for institutional compliance',
    ],
    images: [{ url: logs1, alt: 'Solvenda logs history' }, { url: logs2, alt: 'Solvenda logs history' }],
  },
  {
    icon: <DashboardIcon sx={{ fontSize: 36 }} />,
    title: 'Comprehensive dashboard',
    description:
      'Get an instant overview of your ISP business with high-level analytics on service usage, customer growth, revenue and regional performance.',
    bulletPoints: [
      'Real-time monitoring of network status',
      'Key financial metrics and revenue tracking',
      'Active subscribers and package distribution',
      'Regional performance comparison',
    ],
    images: [
      { url: dash1, alt: 'SOLVENDA dashboard overview' },
      { url: dash2, alt: 'SOLVENDA analytics dashboard' },
      { url: dash3, alt: 'SOLVENDA reports dashboard' },
    ],
  },
  {
    icon: <PeopleIcon sx={{ fontSize: 36 }} />,
    title: 'Customer management',
    description:
      'Keep all your customer information organized and accessible — details, subscriptions, payment history and support interactions in one place.',
    bulletPoints: [
      'Comprehensive customer profiles',
      'Payment history and status',
      'Service subscription tracking',
      'Customer segmentation and targeting',
    ],
    images: [
      { url: payment1, alt: 'Add payment' },
      { url: payment4, alt: 'Add service' },
      { url: payment3, alt: 'Payments' },
    ],
    reversed: true,
  },
  {
    icon: <CreditCardIcon sx={{ fontSize: 36 }} />,
    title: 'Billing & payments',
    description:
      'Simplify billing with automated invoicing, payment tracking and financial reporting. Handle recurring billing, reminders and receipts.',
    bulletPoints: [
      'Multiple payment method support',
      'Payment tracking and reconciliation',
      'Overdue payment management',
    ],
    images: [
      { url: payment2, alt: 'Invoice' },
    ],
  },
  {
    icon: <DescriptionIcon sx={{ fontSize: 36 }} />,
    title: 'Invoicing & warehouse',
    description:
      'Generate professional sale and purchase invoices with Albanian tax compliance, and track items and customers in the built-in warehouse.',
    bulletPoints: [
      'Automated invoice generation',
      'Tax calculation and management',
      'Sale and purchase invoice support',
      'Invoice export to PDF',
    ],
    images: [
      { url: warehouse0, alt: 'Items' },
      { url: warehouse1, alt: 'Items' },
      { url: warehouse2, alt: 'Invoice' },
      { url: warehouse3, alt: 'Invoice' },
    ],
    reversed: true,
  },
  {
    icon: <AssessmentIcon sx={{ fontSize: 36 }} />,
    title: 'Advanced reporting',
    description:
      'Gain detailed insights into every aspect of your ISP business — revenue, customer acquisition, service usage and more.',
    bulletPoints: [
      'Financial performance reports',
      'Customer analytics',
      'Service usage statistics',
      'Export to various formats',
    ],
    images: [
      { url: reporting1, alt: 'Reporting dashboard' },
      { url: reporting2, alt: 'Analytics charts' },
      { url: reporting3, alt: 'Report export options' },
      { url: reporting4, alt: 'Report export options' },
    ],
  },
  {
    icon: <SettingsIcon sx={{ fontSize: 36 }} />,
    title: 'Service management',
    description:
      'Define and manage your service offerings — create packages, set pricing and control availability across customer segments and regions.',
    bulletPoints: [
      'Flexible service package creation',
      'Regional service availability',
      'Promotional offers and discounts',
      'Activation and deactivation workflows',
    ],
    images: [
      { url: service1, alt: 'Service management' },
      { url: service2, alt: 'Service management' },
      { url: service3, alt: 'Service management' },
      { url: service4, alt: 'Service management' },
      { url: service5, alt: 'Service management' },
      { url: service6, alt: 'Service management' },
    ],
    reversed: true,
  },
];

const FeaturesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <Seo
        title="SOLVENDA Features | FreeRadius, OLT Management, Fiscalization & Online Payments"
        description="Explore SOLVENDA's modules: FreeRadius-based SolvendaRadius internet, ZTE OLT & ONU management, Albanian fiscalization, DNS filtering, legal log retention, online card payments, billing, invoicing, warehouse and advanced reporting."
        keywords="ISP management features, FreeRadius, OLT management, ONU provisioning, ZTE OLT, fiscalization, DNS filtering, log retention, online payments, IPTV management, ISP billing"
        path="/features"
      />
      <FeatureHeader />
      {features.map((feature, index) => (
        <FeatureDetailSection key={feature.title} {...feature} index={index} reversed={index % 2 === 1} />
      ))}
    </Box>
  );
};

export default FeaturesPage;
